export const fieldNames = {
  paymentStatus: 'paymentStatus',
};

export const checkSameStatus = (requests) => {
  if (requests.length === 0 || !requests[0]?.invoice) return false;

  const firstInvoice = requests[0].invoice;

  if (firstInvoice.paymentState?.id === 4 || firstInvoice.paymentState?.id === 1) return false;

  return requests.every(
    (item) =>
      item.invoice &&
      item.invoice?.paymentState?.id === firstInvoice?.paymentState?.id &&
      item.invoice?.paymentType?.id === firstInvoice?.paymentType?.id
  );
};